import React from 'react';
import QuoteForm from '../../QuoteForm';
import Navbar4 from '../../Navbar4';
import Cards from '../../cards/Cards2';
import SectionHeader from '../section/SectionHeader';
import kitchenBg from "../../../assets/images/banner-back-1.jpg";


const Basement = () => {
  return (
    <>
     <div className='container-fluid'>
     <SectionHeader title="BASEMENT RENOVATIONS" backgroundImage={kitchenBg} className =""/>
     </div>
         
    <div className="container my-5">
      <div className="row">
       
        <div className="col-lg-9">

      <div className='px-1 my-4'>
  <h1
    className='text-center fw-bold mb-4'
    style={{ fontFamily: 'Barlow Condensed', fontWeight: 'normal', fontSize: '2rem' }}
    data-sal="slide-up"
    data-sal-duration="700"
  >
    Basement Renovations
  </h1>

  <img
    src="assets/Images/Basement/luxury3d.webp"
    className='img-fluid mb-3'
    alt="banner"
    style={{
      width: "100%",
      float: "left",
      height: "200px",
      objectFit: "cover",
      marginTop: "0px",
    }}
    data-sal="zoom-in"
    data-sal-duration="800"
    data-sal-delay="100"
  />

  <p
    className='text-start my-4'
    style={{ fontFamily: 'Barlow Condensed' }}
    data-sal="fade"
    data-sal-duration="700"
  >
    Almost every home in Toronto has a basement, but unfortunately, many are either unfinished or have been previously renovated with less-than-optimal DIY efforts. It’s common to find basements with inadequate insulation, faulty electrical and plumbing work, and other deficiencies. To fully realize the potential of your basement, it’s essential to renovate it with the same meticulous attention to detail as the rest of your home. This not only adds vital living space but also enhances storage and utility areas. At Velar Heights Renovations, we believe your basement should be an extension of your home, utilized just as you would any other room. Whether you envision an entertainment area for hosting guests or a cozy space for your children to play, we are here to turn your ideas into reality.
  </p>

  <h2
    className='text-start'
    style={{ fontFamily: 'Barlow Condensed', fontWeight: 'normal', fontSize: '1.5rem' }}
    data-sal="slide-left"
    data-sal-duration="600"
  >
    The Appeal of a Well-Renovated Basement
  </h2>

  <p
    className='text-start'
    style={{ fontFamily: 'Barlow Condensed' }}
    data-sal="fade"
    data-sal-duration="700"
    data-sal-delay="100"
  >
    One of the most compelling reasons to renovate your basement is the opportunity to add an additional bathroom. Basements often provide ample space, allowing for the installation of luxurious features like a large bathtub, sauna, or walk-in shower that might not be feasible in other bathrooms. This not only adds comfort but also significantly increases the value of your home. Velar Heights Renovations has built a stellar reputation for basement renovations in Toronto, thanks to our exceptional craftsmanship and competitive pricing. Our team of dedicated contractors specializes in transforming basements into stylish and functional spaces tailored to your needs. Our impressive track record and glowing reviews speak volumes about our ability to deliver high-quality renovations that meet your expectations.
  </p>

  <h2
    className='text-start'
    style={{ fontFamily: 'Barlow Condensed', fontWeight: 'normal', fontSize: '1.5rem' }}
    data-sal="slide-right"
    data-sal-duration="600"
  >
    Creating Functional Home Offices and Workspaces
  </h2>

  <p
    className='text-start'
    style={{ fontFamily: 'Barlow Condensed' }}
    data-sal="fade"
    data-sal-duration="700"
    data-sal-delay="100"
  >
    In today’s remote work environment, having a dedicated home office or workspace is crucial. Basements provide a quiet, secluded area ideal for establishing a productive work environment. We can design custom-built desks, ample storage solutions, and ergonomic layouts to ensure your home office is both functional and inspiring. Renovating your basement not only boosts the functionality of your home but also increases its market value. At Velar Heights Renovations, our expertise and creativity ensure that your basement renovation project in Toronto surpasses your expectations. We pride ourselves on delivering a seamless and professional renovation process, with a step-by-step approach that guarantees your basement transformation is smooth, efficient, and adheres to the highest standards. Let us help you unlock your basement’s full potential and create a space that enhances both your home’s value and your quality of life.
  </p>
</div>

        </div>

       
        <div className="col-lg-3 d-flex flex-column justify-content-start">
        <div className="mb-3" style={{ marginTop: '85px' }}> 
          <QuoteForm />
        </div>
        <Navbar4 />
      </div>
      </div>
      </div>

      <div>
        <h1 className='text-center' style={{ fontFamily: 'Barlow Condensed', fontWeight: 'lighter', fontSize: '4rem' }}>Our Portfolio</h1>
      </div>
<div className='container-fluid'>
<Cards/>
</div>
      
   
      </>
  );
};

export default Basement;
